import type { JSX } from 'react'
import type { IButtonProps } from '../Button'

import { IconNames } from 'atoms/Icon'
import { COLOR, INDENTS } from 'vars/index'
import { Button } from '../Button'
import {
  ButtonBordersWidth,
  ButtonColors,
  ButtonCorners,
  ButtonFonts,
} from '../Button.h'

export interface IPrimaryInfoButtonProps extends IButtonProps {}

export const PrimaryInfoButton = ({
  disabled,
  icon = IconNames.info,
  font = ButtonFonts.Button1,
  colorDefault = ButtonColors.COLOR_MAIN_DEFAULT,
  colorHovered = ButtonColors.SURFACE_LIGHT_2,
  colorPressed = ButtonColors.COLOR_MAIN_PRESSED,
  colorDisabled = ButtonColors.COLOR_DISABLED,
  backgroundColorDefault = COLOR.TRANSPARENT,
  backgroundColorDisabled = COLOR.TRANSPARENT,
  borderWidth = ButtonBordersWidth.BORDER_0,
  paddings = [INDENTS.INDENT_0],
  corners = ButtonCorners.CORNERS_10,
  ...rest
}: IPrimaryInfoButtonProps): JSX.Element => {
  return (
    <Button
      icon={icon}
      font={font}
      disabled={!!disabled}
      colorDefault={colorDefault}
      colorHovered={colorHovered}
      colorPressed={colorPressed}
      colorDisabled={colorDisabled}
      backgroundColorDefault={backgroundColorDefault}
      backgroundColorDisabled={backgroundColorDisabled}
      borderWidth={borderWidth}
      paddings={paddings}
      corners={corners}
      {...rest}
    />
  )
}
